import api from './api';

export interface EnsayoMedio {
  id: number;
  medio: string;
}

// Obtener todos los medios de ensayo
export const getEnsayosMedio = async (): Promise<EnsayoMedio[]> => {
  try {
    const response = await api.get('/ensayos-medio');
    return response.data;
  } catch (error) {
    console.error('Error al obtener medios de ensayo:', error);
    // Datos de ejemplo para desarrollo
    return [
      { id: 1, medio: 'Agua' },
      { id: 2, medio: 'Suelo' },
      { id: 3, medio: 'Aire' },
      { id: 4, medio: 'Biológico' },
      { id: 5, medio: 'Alimentos' }
    ];
  }
}; 